import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	OnInit,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { CoreState, CustomerManagementSelector } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { IauiPaymentType, IauiPaymentTypePayload, IauiVerificationPaymentForm } from "./iaui-verification.model";

@Component({
	selector: "obg-m-iaui-verification-container",
	templateUrl: "./iaui-verification.component.html",
	styleUrls: ["./iaui-verification.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IauiVerificationComponent implements OnInit {
	@HostBinding("class.obg-m-iaui-verification") hostCssClass = true;

	@Output() done = new EventEmitter<IauiPaymentTypePayload>();
	customerFirstName$: Observable<string | undefined> | undefined;
	form: IauiVerificationPaymentForm;

	readonly iauiPaymentType = {
		swedbank: IauiPaymentType.Swedbank,
		seb: IauiPaymentType.Seb,
		citadele: IauiPaymentType.Citadele,
		revolut: IauiPaymentType.Revolut,
		luminor: IauiPaymentType.Luminor,
		trustly: IauiPaymentType.Trustly,
	};

	constructor(
		private store: Store<CoreState>,
		private fb: UntypedFormBuilder
	) {
		this.form = this.fb.group({
			paymentType: ["", Validators.required],
		}) as IauiVerificationPaymentForm;
	}

	ngOnInit() {
		this.customerFirstName$ = this.store.select(CustomerManagementSelector.getCustomer).pipe(
			ignoreNil(),
			map((customer) => customer.profile.firstName)
		);
	}

	onDone() {
		if (this.form.valid) {
			this.done.emit(this.form.value);
		}
	}
}
